export const en = {
    delete: 'Delete'
};
